import React from 'react'
import { Heading } from '@patron/patron-react/heading'
import { Paragraph } from '@patron/patron-react/paragraph'

const PREFIX = "app"

const Error404 = () => {
    return (
        <>
            <section>
                <div className="container">
                    <div style={{ marginTop: "5%" }}>
                        <Heading
                            type="h3"
                            className={`hcl-text-center mb-5 ${PREFIX}-login-title`}
                        >
                            HCL T-VREX
                        </Heading>
                    </div>
                </div>
                <div className="container">
                    <div className="blue_active_blue_dark">
                        <div className={`${PREFIX}-login-wrapper`}>
                            <div className="hcl-text-center mb-4 mr-2">
                                <img
                                    style={{ width: "18rem" }}
                                    src="/assets/error404.png"
                                    alt="TVREX"
                                />
                                <Paragraph style={{
                                    fontSize: "15px",
                                    marginTop: "8%"
                                }}>
                                    404 Error - page not found
                                </Paragraph>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Error404
